import { objectSelector } from './utils';

const $PLA = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

const $PLPD = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/productDetail`);

const $PLPL = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/productList`);

const $PLSS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/storeSelection`);

const $PLB = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/basket`);

const $PLC = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/checkout`);

const $PLO = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/order`);

const $PLCL = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/customerList`);

const $PLPOL = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/packageOrderList`);

const $PLCCOL = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/clickAndCollectOrderList`);

const $PLPayOL = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/packageOrderList`);

const $PLPOD = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/packageOrderDetail`);

const $PLCCOD = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/clickAndCollectOrderDetail`);

const $PLTOL = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/theme/transferOrderList`);

export default {
  packageOrderListAutoReload:
    ($PLA.PAGE_AUTO_RELOAD && $PLA.PAGE_AUTO_RELOAD.PACKAGE_ORDER_LIST) || {},
  paymentOrderListAutoReload:
    ($PLA.PAGE_AUTO_RELOAD && $PLA.PAGE_AUTO_RELOAD.PACKAGE_ORDER_LIST) || {},
  transferOrderListAutoReload:
    ($PLA.PAGE_AUTO_RELOAD && $PLA.PAGE_AUTO_RELOAD.TRANSFER_ORDER_LIST) || {},
  clickAndCollectOrderListAutoReload: objectSelector(
    $PLA,
    'PAGE_AUTO_RELOAD.CLICK_AND_COLLECT_ORDER_LIST',
    { active: null, ms: null }
  ),
  hasSmsVerificationForRegister: $PLA.HAS_SMS_VERIFICATION_FOR_REGISTER,
  hasSmsVerificationForLogin: $PLA.HAS_SMS_VERIFICATION_FOR_LOGIN,
  hasPermissionForPages: $PLA.HAS_PERMISSION_FOR_PAGES,

  hasRemoteId: $PLSS.HAS_REMOTE_ID,
  hasBasketCoupon: $PLB.HAS_COUPON,
  hasDeliveryFromStore: $PLC.HAS_DELIVERY_FROM_STORE,
  hasInstallmentOptions: $PLC.HAS_INSTALLMENT_OPTIONS,
  hasOrderRefundInvoiceNumber: $PLO.HAS_REFUND_INVOICE_NUMBER,

  hasCustomerOrderFilter: $PLCL.HAS_ORDER_FILTER,
  hasCustomerFirstNameFilter: $PLCL.HAS_FIRST_NAME_FILTER,
  hasCustomerLastNameFilter: $PLCL.HAS_LAST_NAME_FILTER,
  hasCustomerPhoneFilter: $PLCL.HAS_PHONE_FILTER,
  hasCustomerEmailFilter: $PLCL.HAS_EMAIL_FILTER,
  hasMemberFilterHeader:
    $PLCL.HAS_FIRST_NAME_FILTER ||
    $PLCL.HAS_LAST_NAME_FILTER ||
    $PLCL.HAS_PHONE_FILTER ||
    $PLCL.HAS_EMAIL_FILTER,

  productDetailImageWidth: $PLPD.IMAGE_WIDTH,
  productDetailImageHeight: $PLPD.IMAGE_HEIGHT,
  productDetailImageQuality: $PLPD.IMAGE_QUALITY,
  productDetailColorsImageWidth: $PLPD.COLORS_IMAGE_WIDTH,
  productDetailColorsImageHeight: $PLPD.COLORS_IMAGE_HEIGHT,
  productDetailColorsImageQuality: $PLPD.COLORS_IMAGE_QUALITY,
  productDetailThumbnailImageWidth: $PLPD.THUMBNAIL_IMAGE_WIDTH,
  productDetailThumbnailImageHeight: $PLPD.THUMBNAIL_IMAGE_HEIGHT,
  productDetailThumbnailImageQuality: $PLPD.THUMBNAIL_IMAGE_QUALITY,

  productListImageWidth: $PLPL.IMAGE_WIDTH,
  productListImageHeight: $PLPL.IMAGE_HEIGHT,
  productListImageQuality: $PLPL.IMAGE_QUALITY,

  isPackageOrderListMobileView: $PLPOL.MOBILE_VIEW,
  isPaymentOrderListMobileView: $PLPayOL.MOBILE_VIEW,
  packageOrderListDefaultStatusesToShow: $PLPOL.DEFAULT_STATUSES_TO_SHOW,
  clickAndCollectOrderListDefaultStatusesToShow:
    $PLCCOL.DEFAULT_STATUSES_TO_SHOW,
  paymentOrderListDefaultStatusesToShow: $PLPayOL.DEFAULT_STATUSES_TO_SHOW,
  packageOrderListCollectingStatusesToShow: $PLPOL.COLLECTING_STATUSES_TO_SHOW,
  paymentOrderListCollectingStatusesToShow:
    $PLPayOL.COLLECTING_STATUSES_TO_SHOW,
  packageOrderListPackagingStatusesToShow: $PLPOL.PACKAGING_STATUSES_TO_SHOW,
  paymentOrderListPackagingStatusesToShow: $PLPayOL.PAYMENTING_STATUSES_TO_SHOW,
  packageOrderListDistributionStatusesToShow:
    $PLPOL.DISTRIBUTION_STATUSES_TO_SHOW,
  paymentOrderListDistributionStatusesToShow:
    $PLPayOL.DISTRIBUTION_STATUSES_TO_SHOW,
  packageOrderListDefaultActiveStatus: $PLPOL.DEFAULT_ACTIVE_STATUS,
  packageOrderListCollectingActiveStatus: $PLPOL.COLLECTING_ACTIVE_STATUS,
  packageOrderListPackagingActiveStatus: $PLPOL.PACKAGING_ACTIVE_STATUS,
  clickAndCollectOrderListDefaultActiveStatus: objectSelector(
    $PLCCOL,
    'DEFAULT_ACTIVE_STATUS'
  ),
  packageOrderListDistributionActiveStatus: $PLPOL.DISTRIBUTION_ACTIVE_STATUS,
  hasPackageOrderListDeliveryRange: $PLPOL.HAS_DELIVERY_RANGE,
  hasPaymentOrderListDeliveryRange: $PLPayOL.HAS_DELIVERY_RANGE,
  isPackageOrderListPrintable: objectSelector(
    $PLPOL,
    'PRINT_PACKAGE_ORDER_LIST',
    true
  ),
  isClickAndCollectOrderListPrintable: objectSelector(
    $PLCCOL,
    'PRINT_CLICK_AND_COLLECT_ORDER_LIST',
    true
  ),

  isPackageOrderDetailMobileView: $PLPOD.MOBILE_VIEW,
  isPackageOrderDetailPrintable: $PLPOD.PRINT_ORDER_DETAIL,
  isClickAndCollectOrderDetailPrintable: $PLCCOD.PRINT_ORDER_DETAIL,
  isPackageOrderDetailBarcodeValidationActive: $PLPOD.BARCODE_VALIDATION,
  casesToOpenBarcodeModal: $PLPOD.CASES_TO_OPEN_BARCODE_MODAL || [],
  casesToOpenCargoSelectionModal: $PLPOD.CASES_TO_OPEN_CARGO_SELECTION_MODAL,
  packageOrderDetailModalImageHeight: $PLPOD.IMAGE_HEIGHT,
  packageOrderDetailModalImageWidth: $PLPOD.IMAGE_WIDTH,
  clickAndCollectOrderDetailModalImageHeight: $PLCCOD.IMAGE_HEIGHT,
  clickAndCollectOrderDetailModalImageWidth: $PLCCOD.IMAGE_WIDTH,

  transferOrderListDefaultStatusesToShow: $PLTOL.DEFAULT_STATUSES_TO_SHOW,
  redirectAfterOutOfStock: $PLPOD.REDIRECT_AFTER_OUT_OF_STOCK,
};



// WEBPACK FOOTER //
// ./src/theme/settings.js